import { useEffect, useMemo } from 'react'
import { Box, Flex } from '@mantine/core'

import { DonutChart } from '@/components/@Shared/DonutChart/DonutChart'
import { DonutChartLegend } from '@/components/@Shared/DonutChartLegend/DonutChartLegend'
import { ShadowBox } from '@/components/@Shared/ShadowBox/ShadowBox'
import type { RaceSummaryProps } from '@/components/@Shared/UserManagmentCharts/RaceSummary/RaceSummary.types'
import { Loader } from '@/components/Loader/Loader'
import { Text } from '@/components/Text/Text'
import { Title } from '@/components/Title/Title'

import { getDonutSections, getStats } from '@/helpers/chartData.helper'

import classes from './RaceSummary.module.css'

export function RaceSummary({
  data,
  isLoading,
  onUpdateChartsData,
}: RaceSummaryProps) {
  const chartData = useMemo(() => {
    const stats = getStats(data)

    return getDonutSections(stats)
  }, [data])

  useEffect(() => {
    if (!onUpdateChartsData) return

    onUpdateChartsData(chartData, 'race')
  }, [chartData, onUpdateChartsData])

  return (
    <ShadowBox w="100%">
      <Title variant="h2">Race</Title>

      {!chartData.length ? (
        <Flex align="center" h={75} justify="center">
          {isLoading ? <Loader isMinimized /> : <Text>No data available</Text>}
        </Flex>
      ) : (
        <Flex className={classes.chartContainer}>
          <Box h="223px" pl={24}>
            <DonutChart data={chartData} />
          </Box>
          <DonutChartLegend chartData={chartData} />
        </Flex>
      )}
    </ShadowBox>
  )
}
